export default "__VITE_ASSET__kZjo6UVh__"